import { render, staticRenderFns } from "./IndicatorDesc.vue?vue&type=template&id=1f6b7cd0&scoped=true&"
import script from "./IndicatorDesc.vue?vue&type=script&lang=js&"
export * from "./IndicatorDesc.vue?vue&type=script&lang=js&"
import style0 from "./IndicatorDesc.vue?vue&type=style&index=0&id=1f6b7cd0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6b7cd0",
  null
  
)

export default component.exports